/*
  variant-cards-guard.js
  Save as: assets/variant-cards-guard.js

  Load AFTER variant-cards.js in the snippet:
    <script src="{{ 'variant-cards-guard.js' | asset_url }}" defer="defer"></script>

  Why this exists: the Liquid cutoff check controls how the cards RENDER.
  The add-to-cart button lives in main-product.liquid and knows nothing about
  market dates. This closes that gap.

  It also re-applies itself after every change. variant-cards.js recomputes
  which options are available whenever a selection changes, and that pass
  clears the disabled flag on closed dates — so locking them once at page
  load is not enough.

  Server-side inventory is still the real gate. This is UI honesty, not
  enforcement: a crafted /cart/add.js POST bypasses it entirely.
*/

(function () {
  'use strict';

  var CLOSED_TEXT = 'Pre-orders closed for this date';
  var SOLD_OUT_TEXT = 'Sold out';
  var CHOOSE_TEXT = 'Choose an option';

  function init(root) {
    var dataEl = root.querySelector('[data-variant-cards-data]');
    var formId = root.getAttribute('data-form-id');
    if (!dataEl || !formId) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = document.getElementById(formId) || root.closest('form');
    if (!form) return;

    var button = form.querySelector('[type="submit"]');
    if (!button) return;

    var labelEl = button.querySelector('span') || button;
    var originalText = labelEl.textContent.trim();
    var locking = false;

    /* Closed dates must never be selectable, no matter how many times the
       picker re-renders. */
    function lockClosed() {
      if (locking) return false;
      locking = true;

      var changed = false;
      root.querySelectorAll('.variant-cards__input[data-closed="true"]').forEach(function (input) {
        if (!input.disabled) {
          input.disabled = true;
          changed = true;
        }
        if (input.checked) {
          input.checked = false;
          changed = true;
        }
      });

      locking = false;
      return changed;
    }

    function selectedValues() {
      var count = parseInt(root.getAttribute('data-option-count'), 10) || 1;
      var values = [];
      for (var i = 0; i < count; i++) {
        var checked = root.querySelector('.variant-cards__input[data-option-index="' + i + '"]:checked');
        values.push(checked ? checked.value : null);
      }
      return values;
    }

    function matchVariant(values) {
      return variants.find(function (variant) {
        return values.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function setButton(disabled, text) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      labelEl.textContent = text;
    }

    function update() {
      lockClosed();

      var values = selectedValues();

      if (values.indexOf(null) !== -1) {
        setButton(true, CHOOSE_TEXT);
        return;
      }

      var variant = matchVariant(values);

      if (!variant) {
        setButton(true, 'Unavailable');
      } else if (variant.closed) {
        setButton(true, CLOSED_TEXT);
      } else if (!variant.available) {
        setButton(true, SOLD_OUT_TEXT);
      } else {
        setButton(false, originalText);
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('variant-cards__input')) {
        /* Let variant-cards.js finish its own pass first, then re-lock. */
        setTimeout(update, 0);
      }
    });

    /* Catch re-renders that don't fire a change event on our inputs. */
    var observer = new MutationObserver(function () {
      if (lockClosed()) setTimeout(update, 0);
    });

    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'checked']
    });

    setTimeout(update, 0);
  }

  function boot() {
    document.querySelectorAll('variant-cards').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();